module.exports = __webpack_public_path__ + "img/red-desert-decal-02.0a382d03.png";